import { forwardRef } from 'react';

import { LINK_CONST, type LinkRouterProps } from '../@types';
import { isExactPathname } from '../helpers';
import { Link } from './Link.styles';

const LinkRouter = forwardRef(
  ({ children, exact, onClick, to, ...rest }: LinkRouterProps, ref: LinkRouterProps['ref']) => {
    return (
      <Link.Router
        ref={ref}
        data-active={isExactPathname(to?.pathname ?? '', exact)}
        data-testid={LINK_CONST.TEST_ID}
        onClick={onClick}
        to={to}
        {...rest}
      >
        {children}
      </Link.Router>
    );
  },
);
LinkRouter.displayName = 'LinkRouter';
export default LinkRouter;
